import { render, staticRenderFns } from "./FullWidthImage.vue?vue&type=template&id=eb69b8f8&"
import script from "./FullWidthImage.vue?vue&type=script&lang=js&"
export * from "./FullWidthImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports